module.exports = __webpack_public_path__ + "static/media/kite_surfing_1920.593fbd87.webp";